export default {
  'applications.title': 'Manage Requests',
  'applications.detail.title': 'Request Details {name}',
  'applications.bulkDetail.title': 'Bulk Task Details {name}',
  'applications.detail.application': 'Request',
  'applications.detail.timeline.today': 'Today',
  'applications.detail.timeline.yesterday': 'Yesterday',
  'applications.detail.timeline.autoGroup':
    '{count, plural, one {# automated step completed} other {# automated steps completed}}',
  'applications.detail.timeline.showSteps': 'Show steps',
  'applications.detail.timeline.hideSteps': 'Hide steps',
  'applications.detail.info.more': 'More info',
  'applications.detail.info.less': 'Less info',
  'applications.detail.error.more': 'Show error detail',
  'applications.detail.error.less': 'Hide detail',
  'applications.detail.history.banner.title': 'You are viewing a previous step from the history',
  'applications.detail.history.banner.subtitle':
    'The information shown reflects what was loaded up to this step.',
  'applications.detail.history.banner.back': 'Back to current version',
  'applications.detail.metrics.title': 'Request pulse',
  'applications.detail.metrics.totalDuration': 'Total time',
  'applications.detail.metrics.steps': 'Steps executed',
  'applications.detail.metrics.stepsBreakdown': '{auto} automatic · {manual} manual',
  'applications.detail.metrics.inCurrentStep': 'In current step',
  'applications.detail.metrics.avgPerStep': 'Avg per step',
  'applications.detail.metrics.automation': 'Automation',
  'applications.detail.metrics.bottleneck': 'Longest step',
  'applications.detail.metrics.activity': 'Daily activity',
  'applications.diagram.pulse.bottleneckHint': 'Longest step · click to inspect it',
  'applications.diagram.pulse.rework': 're-executions',
  'applications.diagram.pulse.errors': 'with errors',
  'applications.diagram.inspector.close': 'Close inspector',
  'applications.diagram.inspector.started': 'Started',
  'applications.diagram.inspector.finished': 'Finished',
  'applications.diagram.inspector.duration': 'Duration',
  'applications.diagram.inspector.sinceStart': 'Since request start',
  'applications.diagram.inspector.overdue': 'Due date',
  'applications.diagram.inspector.executions':
    '{count, plural, one {# execution} other {# executions}}',
  'applications.diagram.inspector.bottleneckHint':
    'This is the step that consumed the most time in the request.',
  'applications.diagram.inspector.overdueHint': 'This step went past its due date.',
  'applications.diagram.inspector.notExecuted':
    'This step has not been executed in this request yet.',
  'applications.complete.title': 'Complete Information {name}',
  'applications.complete.titlePrefix': 'Complete Information',
  'applications.text.resendNotification': 'Resend Notification',
  'applications.text.versionHistory': 'Version History',
  'applications.text.loadingText': 'Loading information',
  'applications.text.actions': 'Actions',
  'applications.text.variables': 'Variables',
  'applications.text.template': 'Template',
  'applications.text.capacitation': 'Trainings',
  'applications.text.attachment': 'Attach worker payment receipt',
  'applications.history.title1': 'History',
  'applications.history.title': 'Select the step you want to review',
  'applications.history.subTitle':
    'This action will show the documentation uploaded up to that date:',
  'applications.history.current': 'Current',
  'applications.history.return': 'Return',
  'applications.history.previous': 'Previous',
  'applications.text.form': 'Form',
  'applications.text.forms': 'Forms',
  'applications.text.comments': 'Comments',
  'applications.comments.empty.title': 'Comments',
  'applications.comments.empty.description': 'Comments help you chat with users within a request.',
  'applications.comments.empty.cta': "Let's send your first comment",
  'applications.comments.empty.alt': 'Comments illustration',
  'applications.comments.mentions.empty': 'No users found',
  'applications.comments.actions.edit': 'Edit comment',
  'applications.comments.actions.save': 'Save',
  'applications.comments.actions.cancel': 'Cancel',
  'applications.comments.actions.delete': 'Delete comment',
  'applications.comments.actions.update': 'Edit',
  'applications.comments.actions.delete.confirm': 'Delete this comment?',
  'applications.comments.actions.delete.ok': 'Delete',
  'applications.comments.actions.delete.cancel': 'Cancel',
  'applications.comments.actions.delete.description': 'This comment will be permanently removed.',
  'applications.comments.edit.validation': 'Please write a comment before saving.',
  'applications.comments.edit.title': 'Edit comment',
  'applications.comments.timestamp.edited': 'edited',
  'applications.comments.timestamp.editedBy': 'edited by {name}',
  'applications.text.notifyUsers': 'Notify Users',
  'applications.text.writeComment': 'Write a Comment',
  'applications.text.mailsTracking': 'Email',
  'applications.text.engine': 'Executions',
  'applications.text.traces': 'Tracking',
  'applications.text.reassignedTasks': 'Reassigned',
  'applications.text.reassigned.sourceUser': 'Source User',
  'applications.text.reassigned.destinationUser': 'Destination User',
  'applications.text.reassigned.reason': 'Reason',
  'applications.text.reassigned.detailTitle': 'Reassigned Task Detail',
  'applications.text.commandTraces': 'Actions',
  'applications.text.command.commandType': 'Type',
  'applications.text.command.data': 'Data',
  'applications.text.commandType.details': 'Details',
  'applications.text.commandType.approve': 'Approve',
  'applications.text.commandType.reject': 'Reject',
  'applications.text.commandType.complete': 'Completed',
  'applications.text.commandType.executeTask': 'Executed',
  'applications.text.commandType.sign': 'Sign',
  'applications.text.commandType.cancel': 'Cancel Request',
  'applications.text.commandType.void': 'Void Request',
  'applications.text.commandType.sendNotifications': 'Resend Notifications',
  'applications.text.commandType.evaluateApprovers': 'Evaluate Approvers',
  'applications.text.commandType.backToStep': 'Revert Request',
  'applications.text.commandType.reassignTask': 'Reassign Task',
  'applications.text.commandType.executeAutomaticAction': 'Execute Automatic Action',
  'applications.text.commandType.history': 'Version History',
  'applications.text.commandType.continue': 'Edit',
  'applications.text.commandType.autoAssignTask': 'Auto-assign Task',
  'applications.text.commandType.goToStep': 'Advance Request',
  'applications.text.commandType.removeProcessInstance': 'Remove Request',
  'applications.text.commandType.clearError': 'Reevaluate Error',
  'applications.text.commandType.startRequest': 'Start Request',
  'applications.text.commandType.goToActionFromCustomCommand': 'Go to Action from Custom Command',
  'applications.text.commandType.aiInteract': 'Interact with AI',
  'applications.text.engine.id': 'ID',
  'applications.text.engine.importance': 'Importance',
  'applications.text.engine.created': 'Created',
  'applications.text.engine.importance.none': 'None',
  'applications.text.engine.importance.low': 'Low',
  'applications.text.engine.importance.medium': 'Medium',
  'applications.text.engine.importance.high': 'High',
  'applications.text.engine.importance.urgent': 'Urgent',
  'applications.text.engine.importance.critical': 'Critical',
  'applications.text.engine.importance.unknown': 'Unknown',
  'applications.text.engine.operationType.evaluateApprovers': 'Evaluate Approvers',
  'applications.text.engine.operationType.handleNotifications': 'Send Notifications',
  'applications.text.engine.operationType.handleAutomaticActions': 'Manage Automatic Action',
  'applications.text.engine.operationType.handleOverdue': 'Manage Expiration',
  'applications.text.engine.operationType.handleApprovalReminderNotifications':
    'Send Approval Reminder Notifications',
  'applications.text.engine.operationType.handleIteration': 'Manage Automatic Action / Iteration',
  'applications.text.engine.operationType.handleEntityOperation':
    'Manage Automatic Action / Dynamic Entity Operation',
  'applications.text.engine.operationType.attachmentsCopy': 'Copy Attachments',
  'applications.text.engine.operationType.handleFinishCompleteInformationCompleted':
    'Handling Completion of Action to Complete Information Completed',
  'applications.text.engine.operationType.handleRunCode': 'Manage Automatic Action / Run Code',
  'applications.text.engine.operationType.handleWaitChildRequestsReevaluate':
    'Handle Automatic Action / Reevaluate Child Requests Status',
  'applications.text.engine.operationType.reevaluateEmailTrackingEvents':
    'Reevaluate Email Tracking',
  'applications.text.engine.operationType.autoSuccessEmailTrackingAfterStabilization':
    'Mark Email Tracking as Successful after Stabilization',
  'applications.loading.results': 'Loading results',
  'applications.text.tabDocumentsTitle': 'Your documents ({count})',
  'applications.text.tabMailsTitle': 'Email tracking ({count})',
  'applications.text.tabTraceRecords': '{count} tracking records',
  'applications.text.errorTitle': 'Request with Errors',
  'applications.text.securityCode': 'PIN',
  'applications.text.itemsAffected': 'Affected Elements',
  'applications.text.itemsCount': 'Elements Count',
  'applications.text.insertItems': 'Elements to Add',
  'applications.text.opsResultStatus': 'Operation Result Status',
  'applications.text.handlerType': 'Handler Type',
  'applications.text.model': 'Model',

  'applications.text.observations': 'Observations',
  'applications.text.chatMessageContent': 'Message Content',
  'applications.text.chatInternalTaskId': 'Chat Internal Task ID',
  'applications.text.finishedDate': 'Finished Date',
  'applications.text.executeApiCall.results': 'API Call Results',
  'applications.text.executeApiCall.result': 'API Call Result',
  'applications.text.integration.results': 'API Call Result',
  'applications.text.dynamicEntityOperation.results': 'Dynamic Entity Operation Results',
  'applications.text.dynamicEntityOperation.result': 'Dynamic Entity Operation Result',
  'applications.text.consumeSequence.results': 'Consume Sequence Operation Result',
  'applications.text.executeRpaFlow.results': 'RPA Call Results',
  'applications.text.executeRpaFlow.result': 'RPA Call Result',
  'applications.text.internalOperation.results': 'Internal Operation Results',
  'applications.text.internalOperation.result': 'Internal Operation Result',
  'applications.text.internalOperation.success': 'Success',
  'applications.text.internalOperation.error': 'Error',
  'applications.text.internalOperation.operationStatus': 'Operation Status',
  'applications.text.internalOperation.type': 'Operation Type',
  'applications.text.internalOperation.successDescription': 'Operation completed {status}',
  'applications.text.mappingFilters': 'Mapping Filters',
  'applications.text.mappingTableFilters': 'Mapping Table Filters',
  'applications.text.updateValues': 'Update Values',
  'applications.text.affectedItems': 'Items Affected',
  'applications.text.itemsAffected.one': 'One',
  'applications.text.itemsAffected.all': 'All',
  'applications.text.itemsAffected.custom': 'Custom',
  'applications.text.internalOperationType.search': 'Search',
  'applications.text.internalOperationType.add': 'Add',
  'applications.text.internalOperationType.modify': 'Modify',
  'applications.text.internalOperationType.activate': 'Activate',
  'applications.text.internalOperationType.deactivate': 'Deactivate',
  'applications.text.internalOperationType.remove': 'Remove',
  'applications.text.internalOperationType.count': 'Count',
  'applications.text.internalOperationType.canceldelegation': 'Cancel Delegation',
  'applications.text.conditional.results': 'Conditional Evaluation Result',
  'applications.text.setVariable.results': 'Set Variable Operation Result',
  'applications.text.setFormData.results': 'Set Form Data Operation Result',
  'applications.text.iterate.table': 'Table to Iterate',
  'applications.text.iterate.form': 'Form to Iterate',
  'applications.text.iterate.attachment': 'Field Attachment to Iterate',
  'applications.text.iterate.entity': 'Entity to Iterate',
  'applications.text.iterate.results': 'Iteration Results',
  'applications.text.switch.results': 'Evaluation Result',
  'applications.text.internalOperation.results': 'Internal Operation Result',
  'applications.text.completeInformation.results': 'Webhook Operation Result',
  'applications.text.sendEmail.results': 'Send Email Results',
  'applications.text.sendEmail.result': 'Send Email Result',
  'applications.text.sendEmail.emailTrackingAwaitingHint':
    'Waiting for confirmation of the sent email. AUTOMY is monitoring delivery events to continue the flow when the validation is completed or the wait deadline is reached.',
  'applications.text.emailTrackingResult.results': 'Email tracking result',
  'applications.text.emailTrackingResult.result': 'Email delivery tracking',
  'applications.text.emailTrackingResult.summary.validationMode': 'Validation mode',
  'applications.text.emailTrackingResult.summary.waitDeadlineDateTime': 'Wait deadline',
  'applications.text.emailTrackingResult.summary.deliveryStabilizationTimeUnit':
    'Delivery stabilization time unit',
  'applications.text.emailTrackingResult.summary.deliveryStabilizationTimeValue':
    'Delivery stabilization time value',
  'applications.text.emailTrackingResult.summary.deliveryStabilizationDeadlineDateTime':
    'Delivery stabilization deadline',
  'applications.text.emailTrackingResult.summary.deliveredDateTime': 'Delivered at',
  'applications.text.emailTrackingResult.summary.lastEvent': 'Last event',
  'applications.text.emailTrackingResult.summary.finalEvent': 'Final event',
  'applications.text.mailTrackingValidationMode.delivery': 'Delivery',
  'applications.text.mailTrackingValidationMode.open': 'Open',
  'applications.text.mailTrackingValidationMode.click': 'Click',
  'applications.text.openAi.results': 'Open AI Call Results',
  'applications.text.openAi.result': 'Open AI Call Result',
  'applications.text.automyAi.results': 'Automy AI Results',
  'applications.text.automyAI.result': 'Automy AI Result',
  'applications.text.automyAI.chatWithAgent': 'Interact',
  'applications.text.runCode.results': 'Operation Results',
  'applications.text.runCode.result': 'Operation Result',
  'applications.text.teams': 'Teams',
  'applications.text.sms': 'SMS',
  'applications.text.microsoftTeamsIntegration.results': 'Teams Messages',
  'applications.text.microsoftTeamsIntegration.result': 'Teams Message',
  'applications.text.sendSms.results': 'SMS Messages',
  'applications.text.sendSms.result': 'SMS Message',
  'applications.text.sms.connectionName': 'Connection',
  'applications.text.sendMail.details': 'Details',
  'applications.text.sendMail.history': 'Event History',
  'applications.text.googleIntegration.connection': 'Connection',
  'applications.text.whatsAppBusinessIntegration.connection': 'Connection',
  'applications.text.overdueDateTime': 'Due Date and Time',

  'applications.text.runCode.status': 'Status',
  'applications.text.runCode.status.pending': 'Pending',
  'applications.text.runCode.status.installing': 'Installing',
  'applications.text.runCode.status.running': 'Running',
  'applications.text.runCode.status.completed': 'Completed',
  'applications.text.runCode.status.failed': 'Failed',
  'applications.text.runCode.status.expired': 'Expired',
  'applications.text.runCode.status.error': 'Error',
  'applications.text.runCode.status.notfound': 'Not Found',

  'applications.text.rpaInstanceSendStatus.pending': 'Pending',
  'applications.text.rpaInstanceSendStatus.sent': 'Sent',
  'applications.text.rpaInstanceSendStatus.error': 'Error',
  'applications.text.rpaInstanceSendStatus.offlineAgent': 'Offline Agent',

  'applications.text.rpaInstanceResponseStatus.pending': 'Pending',
  'applications.text.rpaInstanceResponseStatus.success': 'Success',
  'applications.text.rpaInstanceResponseStatus.error': 'Error',
  'applications.text.responseTicket': 'Response Ticket',
  'applications.text.lastStatusCheckDate': 'Last Status Check Date',
  'applications.text.finishedDateTime': 'Finished Date Time',
  'applications.text.iterateSteps': 'Iteration Steps',

  'applications.text.sendMail.messageId': 'Message ID',
  'applications.text.sendMail.uniqueArgs': 'Unique Args.',
  'applications.text.sendMail.responseCode': 'Response Code',

  'applications.text.progress': 'Completed',
  'applications.text.moreActions': 'Other Actions',
  'applications.text.originIp': 'Origin IP',
  'applications.text.originDomain': 'Origin Domain',
  'applications.text.parameters': 'Parameters',
  'applications.text.insertedData': 'Inserted Data',

  'applications.text.entityOperation': 'Operation',
  'applications.text.created': 'Creation Date',
  'applications.text.executionOrder': 'Execution Order',
  'applications.text.affectedItems': 'Affected Items',
  'applications.text.startedDateTime': 'Start Processing',
  'applications.text.finishedDateTime': 'Completion Date',
  'applications.text.data': 'Data',
  'applications.text.updated': 'Updated Date',
  'applications.text.processingAttempts': 'Processing Attempts',

  'application.text.iterationDynamicEntity': 'Dynamic Entity: {name}',
  'application.text.iterationForm': 'Form: {name}',
  'application.text.iterationTable': 'Table: {name}',

  'applications.text.sendStatus': 'Send Status',
  'applications.text.sentData': 'Sent Data',
  'applications.text.responseStatus': 'Response Status',

  'applications.text.entity': 'Entity',
  'applications.text.dynamicEntity.operation': 'Dynamic Entity Operation',
  'applications.text.dynamicEntity.affected': 'Affected Items',
  'applications.text.dynamicEntity.quantity': 'Items Quantity',
  'applications.text.dynamicEntity.filters': 'Filters',
  'applications.text.dynamicEntity.tableFilters': 'Filters / Table',
  'applications.text.dynamicEntity.response': 'Response',

  'applications.text.documents': 'Documents',
  'applications.text.documents.viewList': 'List view',
  'applications.text.documents.viewGrid': 'Grid view',
  'applications.text.generatedDocuments': 'Generated Documents',
  'applications.text.loadingMore': 'Loading additional configurations...',

  'applications.text.sendNotifications': 'The notification has been resent.',
  'applications.text.approveNotification': 'The request has been approved.',
  'applications.text.voidNotification': 'The request has been rejected.',
  'applications.text.cancelNotification': 'The request has been canceled.',

  'variablesInfo.internalName': 'Internal Name',
  'variablesInfo.type': 'Type',
  'variablesInfo.initialValue': 'Initial Value',

  'applications.text.bulkTask.detail': 'Detail',
  'applications.text.bulkTask.all': 'Items',
  'applications.text.bulkTask.pending': 'Items - Pending',
  'applications.text.bulkTask.done': 'Items - Ok',
  'applications.text.bulkTask.failure': 'Items - Error',

  'applications.text.bulkTask.lineNumber': 'Line Number',
  'applications.text.bulkTask.bulkRequestNumber': 'Request No. (Excel)',
  'applications.text.bulkTask.operation': 'Successful Operation?',
  'applications.text.bulkTask.request': 'Request',
  'applications.text.bulkTask.totalRequests': 'Total Requests',
  'applications.text.bulkTask.failureKind': 'Failure Kind',
  'applications.text.bulkTask.failureKind.transient': 'Transient',
  'applications.text.bulkTask.failureKind.functional': 'Functional',
  'applications.text.bulkTask.failureKind.invalidFile': 'Invalid File',
  'applications.text.bulkTask.failureKind.corruptedFile': 'Corrupted File',
  'applications.text.bulkTask.failureKind.resourceLimitExceeded': 'Resource Limit Exceeded',
  'applications.text.bulkTask.failureKind.unexpected': 'Unexpected',
  'applications.text.bulkTask.retryDisposition': 'Retry Disposition',
  'applications.text.bulkTask.retryDisposition.retryable': 'Retryable',
  'applications.text.bulkTask.retryDisposition.nonRetryable': 'Non-Retryable',
  'applications.text.bulkTask.retryDisposition.manualReview': 'Manual Review',
  'applications.text.bulkTask.failureCode': 'Failure Code',

  'applications.text.bulkTaskType0': 'Pending',
  'applications.text.bulkTaskType1': 'Processing',
  'applications.text.bulkTaskType2': 'Processed',
  'applications.text.bulkTaskType3': 'Error',
  'applications.text.bulkTaskType4': 'Processing Task Items',
  'applications.text.bulkTaskType5': 'Canceled',

  'applications.text.dynamicEntityOperationType1': 'Search',
  'applications.text.dynamicEntityOperationType2': 'Add',
  'applications.text.dynamicEntityOperationType3': 'Modify',
  'applications.text.dynamicEntityOperationType4': 'Delete',
  'applications.text.dynamicEntityOperationType5': 'Count',
  'applications.text.dynamicEntityOperationType6': 'Sum',
  'applications.text.dynamicEntityOperationType7': 'Subtract',
  'applications.text.dynamicEntityOperationType8': 'Increase',
  'applications.text.dynamicEntityOperationType9': 'Decrease',
  'applications.text.dynamicEntityOperationType10': 'Evaluate Formula',

  'application.text.whatsAppBusinessOperationType.send-message': 'Send Message',

  'application.text.processTriggerIdentifier': 'Message Identifier',
  'application.text.processTriggerSender': 'Sender',

  'applications.text.engineVersionType1': 'V1',
  'applications.text.engineVersionType2': 'V2',

  'applications.text.actionType0': 'Default Initial',
  'applications.text.actionType1': 'Complete Information',
  'applications.text.actionType2': 'Approval',
  'applications.text.actionType3': 'Automatic Approval',
  'applications.text.actionType4': 'Conditional',
  'applications.text.actionType5': 'Execute Task',
  'applications.text.actionType6': 'Execute API Call',
  'applications.text.actionType7': 'Automatic Rejection',
  'applications.text.actionType8': 'Digital Signature',
  'applications.text.actionType9': 'Send Email',
  'applications.text.actionType10': 'Execute Database Query',
  'applications.text.actionType11': 'Operation on Dynamic Entity',
  'applications.text.actionType12': 'Generate Excel',
  'applications.text.actionType13': 'Start Process',
  'applications.text.actionType14': 'Set Variable',
  'applications.text.actionType15': 'Set Form Data',
  'applications.text.actionType16': 'Parallel',
  'applications.text.actionType17': 'Generate Documents',
  'applications.text.actionType18': 'Scheduled Execution',
  'applications.text.actionType19': 'SharePoint Operation',
  'applications.text.actionType20': 'Iterate / Apply to Each',
  'applications.text.actionType21': 'Switch',
  'applications.text.actionType22': 'Internal Operation',
  'applications.text.actionType23': 'Generate Text File',
  'applications.text.actionType24': 'Import Plain Text File',
  'applications.text.actionType25': 'Consume Sequence',
  'applications.text.actionType26': 'Execute RPA Flow',
  'applications.text.actionType27': 'Integration',
  'applications.text.actionType28': 'Automatic Cancel',
  'applications.text.actionType29': 'Automatic Annulment',
  'applications.text.actionType30': 'Open AI',
  'applications.text.actionType31': 'Execute Process Action',
  'applications.text.actionType32': 'Google Integration',
  'applications.text.actionType33': 'Revert Cancellation',
  'applications.text.actionType34': 'Revert Voiding',
  'applications.text.actionType35': 'FTP Operation',
  'applications.text.actionType36': 'Run Code',
  'applications.text.actionType37': 'Automy AI',
  'applications.text.actionType38': 'WhatsApp Business Integration',
  'applications.text.actionType39': 'Microsoft Teams Integration',
  'applications.text.actionType40': 'Wait for Child Requests',
  'applications.text.actionType41': 'Send SMS',

  'applications.text.logicalOperatorType0': 'OR',
  'applications.text.logicalOperatorType1': 'AND',

  'applications.text.myRequests': 'My Requests',
  'applications.text.receivedRequests': 'Received',
  'applications.text.revisionRequests': 'Revision',
  'applications.text.allRequests': 'All',
  'applications.text.bulkRequests': 'Bulk Upload',

  'applications.text.cancellationReason': 'Cancellation Reason',
  'applications.text.rejectedReason': 'Rejection Reason',
  'applications.text.voidedReason': 'Voided Reason',

  'applications.text.requestType0': 'Request on Evaluation',
  'applications.text.requestType1': 'Request Approved',
  'applications.text.requestType2': 'Request Rejected',
  'applications.text.requestType3': 'Request Canceled',
  'applications.text.requestType4': 'Request Voided',
  'applications.text.requestType5': 'Request with Error',

  'applications.text.actionType.0': 'Initiated By',
  'applications.text.actionType.1': 'Form',
  'applications.text.actionType.3': 'Action automatically approved by the system',
  'applications.text.actionType.4': 'Approval Result',
  'applications.text.actionType.7': 'Action automatically rejected by the system',
  'applications.text.actionType.6': 'API Connection',
  'applications.text.actionType.10': 'Database Connection',
  'applications.text.actionType.11': 'Dynamic Entity',
  'applications.text.actionType.13': 'Process',
  'applications.text.actionType.18': 'Scheduled Execution Date and Time',
  'applications.text.actionType.19': 'SharePoint Configuration',
  'applications.text.actionType.20': 'Data Source to Iterate',
  'applications.text.actionType.22': 'Internal Operation',
  'applications.text.actionType.23': 'Format',
  'applications.text.actionType.24': 'Format',
  'applications.text.actionType.25': 'Sequence',
  'applications.text.actionType.26': 'RPA Agent',
  'applications.text.actionType.27': 'Integration',
  'applications.text.actionType.28': 'Auto Cancel',
  'applications.text.actionType.29': 'Auto Annul',
  'applications.text.actionType.30': 'Open AI',
  'applications.text.actionType.31': 'Execute Action',
  'applications.text.actionType.32': 'Google Integration',
  'applications.text.actionType.33': 'Revert Cancellation',
  'applications.text.actionType.34': 'Revert Voiding',
  'applications.text.actionType.35': 'FTP Operation',
  'applications.text.actionType.36': 'Run Code',
  'applications.text.actionType.37': 'Handler Type',

  'applications.text.valueSourceType1': 'Form / Field',
  'applications.text.valueSourceType2': 'Variable',
  'applications.text.valueSourceType3': 'Current Step Iteration',

  'applications.text.originValue': 'Fixed Value',
  'applications.text.destinationForm': 'Destination Form',
  'applications.text.destinationField': 'Destination Field',
  'applications.text.value': 'Value',
  'applications.text.field': 'Field',
  'applications.text.variable': 'Variable',
  'applications.text.operator': 'Operator',
  'applications.text.conditionValue': 'Condition Value',
  'applications.text.evaluationValue': 'Evaluation Value',
  'applications.text.evaluationObservations': 'Result',
  'applications.text.valueSource': 'Value Source',

  'applications.text.actionInstanceStatus.3': 'Expiration Date and Time Reached',
  'applications.text.execution': 'Execution',

  'applications.text.responseError': 'Error Message',
  'applications.text.responseStatusCode': 'Response Code',
  'applications.text.responseData': 'Response Data',
  'applications.text.requestPayload': 'Sent Data',
  'applications.text.requestUrl': 'Request URL',

  'applications.text.sequencePattern': 'Sequence Pattern',
  'applications.text.sequenceItemPattern': 'Sequence Item Pattern',
  'applications.text.generatedNumber': 'Generated Number',
  'applications.text.sequenceItemId': 'Subsequence Identifier',
  'applications.text.sequenceTraceId': 'Sequence Trace Identifier',

  'applications.text.requestMethod0': '? ',
  'applications.text.requestMethod1': 'POST',
  'applications.text.requestMethod2': 'GET',
  'applications.text.requestMethod3': 'PUT',
  'applications.text.requestMethod4': 'DELETE',

  'applications.text.variableType1': 'Text',
  'applications.text.variableType2': 'Number',
  'applications.text.variableType3': 'Date and Time',
  'applications.text.variableType4': 'Date',
  'applications.text.variableType5': 'Time',
  'applications.text.variableType6': 'Matrix',
  'applications.text.variableType7': 'Document',

  'applications.text.startModeType1': 'Manual Flow',
  'applications.text.startModeType2': 'Automated Flow',
  'applications.text.startModeType3': 'Scheduled Flow',

  'applications.text.document.type': 'Type',
  'applications.text.document.user': 'Owner',
  'applications.text.document.filename': 'Name',
  'applications.text.document.created': 'Last Modified',
  'applications.text.document.size': 'File Size',
  'applications.text.document.contentType': 'Content Type',
  'applications.text.document.form': 'Form',
  'applications.text.document.field': 'Field',
  'applications.text.document.actionName': 'Action',

  'applications.text.Attachment': 'Attachment',
  'applications.text.Generated': 'Generated',
  'applications.text.VariableAttachment': 'Variable Attachment',
  'applications.text.TableAttachment': 'Table Attachment',
  'applications.text.CommentAttachment': 'Comment Attachment',

  'applications.text.email.detail': 'Email Traces Details',
  'applications.text.mail.event': 'Event',
  'applications.text.mail.date': 'Date',
  'applications.text.mail.smtpId': 'SmtpId',

  'applications.text.email.id': 'Id',
  'applications.text.email.messageType': 'Type',
  'applications.text.email.email': 'Email',
  'applications.text.email.eventDate': 'Event Date',
  'applications.text.email.smtpId': 'SmtpId',
  'applications.text.email.eventId': 'EventId',
  'applications.text.email.messageId': 'MessageId',
  'applications.text.email.mailEventDescription': 'Event',
  'applications.text.email.mailEventLongDescription': 'Description',
  'applications.text.email.created': 'Creation Date',
  'applications.text.email.reason': 'Reason',
  'applications.text.email.userAgent': 'User Agent',
  'applications.text.email.ip': 'IP',
  'applications.text.email.environment': 'Environment',

  'applications.text.operationType.search': 'Search',
  'applications.text.operationType.add': 'Add',
  'applications.text.operationType.modify': 'Modify',
  'applications.text.operationType.delete': 'Delete',
  'applications.text.operationType.remove': 'Remove',
  'applications.text.operationType.count': 'Count',
  'applications.text.operationType.sum': 'Sum',
  'applications.text.operationType.subtract': 'Subtract',
  'applications.text.operationType.increase': 'Increase',
  'applications.text.operationType.decrement': 'Decrease',
  'applications.text.operationType.evaluate-formula': 'Evaluate Formula',

  'applications.text.dynamicEntityOperationType.search': 'Search',
  'applications.text.dynamicEntityOperationType.add': 'Add',
  'applications.text.dynamicEntityOperationType.modify': 'Modify',
  'applications.text.dynamicEntityOperationType.remove': 'Delete',
  'applications.text.dynamicEntityOperationType.count': 'Count',
  'applications.text.dynamicEntityOperationType.sum': 'Sum',
  'applications.text.dynamicEntityOperationType.subtraction': 'Subtraction',
  'applications.text.dynamicEntityOperationType.increment': 'Increment',
  'applications.text.dynamicEntityOperationType.decrement': 'Decrement',
  'applications.text.dynamicEntityOperationType.evaluateformula': 'Evaluate Formula',
  'applications.text.dynamicEntityOperationType.evaluate-formula': 'Evaluate Formula',
  'applications.text.internalOperationType.search': 'Search',
  'applications.text.internalOperationType.add': 'Add',
  'applications.text.internalOperationType.modify': 'Modify',
  'applications.text.internalOperationType.activate': 'Activate',
  'applications.text.internalOperationType.deactivate': 'Deactivate',
  'applications.text.internalOperationType.remove': 'Delete',
  'applications.text.internalOperationType.count': 'To count',
  'applications.text.internalOperationType.cancel-delegation': 'Revoke Delegation',

  'application.text.sharePointOperationType1': 'Upload File',
  'application.text.sharePointOperationType.upload-file': 'Upload File',
  'application.text.sharePointOperationType.download-file': 'Download File',

  'applications.text.iterationDataSourceType1': 'Form Table',
  'applications.text.iterationDataSourceType2': 'Dynamic Entity',
  'applications.text.iterationDataSourceType3': 'Form Field Attachment',
  'applications.text.iterationDataSourceType.form-table': 'Form Table',
  'applications.text.iterationDataSourceType.dynamic-entity': 'Dynamic Entity',
  'applications.text.iterationDataSourceType.form-field-attachment': 'Form Field Attachment',

  'applications.text.internalOperationEntityType.user': 'User',
  'applications.text.internalOperationEntityType.position': 'Position',
  'applications.text.internalOperationEntityType.area': 'Area',
  'applications.text.internalOperationEntityType.user-group': 'User Group',
  'applications.text.internalOperationEntityType.user-group-user': 'User Group User',
  'applications.text.internalOperationEntityType.environment': 'Environment',
  'applications.text.internalOperationEntityType.chat-thread-participant': 'Chat Participant',
  'applications.text.internalOperationEntityType.ai-agent-vector': 'AI Agent / Training Vector',
  'applications.text.internalOperationEntityType.environment-user': 'Environment User',
  'applications.text.internalOperationEntityType.delegation': 'Delegation',
  'applications.text.internalOperationEntityType.delegation-configuration':
    'Delegation Configuration',
  'applications.text.internalOperationEntityType.global-entity-approver-by-areas':
    'Global Entity Approver By Areas',
  'applications.text.internalOperationEntityType.global-entity-approver-by-positions':
    'Global Entity Approver By Positions',
  'applications.text.internalOperationEntityType.global-entity-approver-by-user-groups':
    'Global Entity Approver By User Groups',
  'applications.text.internalOperationEntityType.global-entity-approver-by-users':
    'Global Entity Approver Users',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-areas':
    'Global User Group Approver By Areas',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-positions':
    'Global User Group Approver By Positions',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-users':
    'Global User Group Approver Users',
  'applications.text.internalOperationEntityType.report-trace': 'Report Trace',
  'applications.text.internalOperationEntityType.internal-task': 'Internal Task',
  'applications.text.internalOperationEntityType.process-instance': 'Process Instance',

  'applications.text.internalOperationEntityType1': 'User',
  'applications.text.internalOperationEntityType2': 'Position',
  'applications.text.internalOperationEntityType3': 'Area',
  'applications.text.internalOperationEntityType4': 'User Group',
  'applications.text.internalOperationEntityType5': 'User Group User',
  'applications.text.internalOperationEntityType6': 'Environment',
  'applications.text.internalOperationEntityType7': 'Environment User',
  'applications.text.internalOperationEntityType8': 'Delegation',
  'applications.text.internalOperationEntityType9': 'Delegation Configuration',
  'applications.text.internalOperationEntityType10': 'Global Entity Approver By Areas',
  'applications.text.internalOperationEntityType11': 'Global Entity Approver By Positions',
  'applications.text.internalOperationEntityType12': 'Global Entity Approver By User Groups',
  'applications.text.internalOperationEntityType13': 'Global Entity Approver Users',
  'applications.text.internalOperationEntityType14': 'Global User Group Approver By Areas',
  'applications.text.internalOperationEntityType15': 'Global User Group Approver By Positions',
  'applications.text.internalOperationEntityType16': 'Global User Group Approver Users',
  'applications.text.internalOperationEntityType17': 'Report Trace',
  'applications.text.internalOperationEntityType18': 'Internal Task',
  'applications.text.internalOperationEntityType19': 'Process Instance',
  'applications.text.internalOperationEntityType20': 'Chat Participant',
  'applications.text.internalOperationEntityType21': 'AI Agent / Training Vector',

  'applications.text.processInstanceFormFieldAttachment': 'Attachment',
  'applications.text.processInstanceGeneratedDocument': 'Generated Document',
  'applications.text.processInstanceVariableAttachment': 'Attachment',
  'applications.text.processInstanceCommentAttachment': 'Attachment',
  'applications.text.entityAttachment': 'Attachment',
  'applications.text.processInstanceApiCallAttachment': 'Attachment',
  'applications.text.listExportGeneratedFile': 'Generated File',
  'applications.text.dynamicEntityExportGeneratedFile': 'Generated File',
  'applications.text.dynamicEntityImportGeneratedErrorFile': 'Generated Error File',
  'applications.text.processInstanceOpenAICallAttachment': 'Attachment',
  'applications.text.processInstanceAutomyAIAttachment': 'Attachment',
  'applications.text.processInstanceRunCodeAttachment': 'Attachment',
  'applications.text.chatThreadAttachment': 'Attachment',
  'applications.text.configurationEntityExportGeneratedFile': 'Generated File',
  'applications.text.configurationEntityImportGeneratedErrorFile': 'Generated Error File',
  'applications.text.manualUpload': 'Manual Upload',

  'applications.text.actionInstanceStatus0': 'Pending',
  'applications.text.actionInstanceStatus1': 'Sent',
  'applications.text.actionInstanceStatus2': 'Error',

  'applications.text.action.instanceStatus0': 'Pending',
  'applications.text.action.instanceStatus1': 'Completed',
  'applications.text.action.instanceStatus2': 'Rejected',
  'applications.text.action.instanceStatus3': 'Expired',
  'applications.text.action.instanceStatus4': 'Omitted',
  'applications.text.action.instanceStatus5': 'Error',
  'applications.text.action.instanceStatus6': 'Executed',

  'applications.text.comparisonOperatorType1': 'Equal',
  'applications.text.comparisonOperatorType2': 'Not Equal',
  'applications.text.comparisonOperatorType3': 'Greater Than',
  'applications.text.comparisonOperatorType4': 'Greater Than or Equal',
  'applications.text.comparisonOperatorType5': 'Less Than',
  'applications.text.comparisonOperatorType6': 'Less Than or Equal',
  'applications.text.comparisonOperatorType7': 'Contains',
  'applications.text.comparisonOperatorType8': 'Does Not Contain',
  'applications.text.comparisonOperatorType9': 'Is Null',
  'applications.text.comparisonOperatorType10': 'Is Not Null',

  'applications.text.plainTextFileFormat.json': 'JSON',
  'applications.text.plainTextFileFormat.text': 'TXT',
  'applications.text.plainTextFileFormat.csv': 'CSV',
  'applications.text.plainTextFileFormat.xml': 'XML',
  'applications.text.plainTextFileFormat.parquet': 'PARQUET',

  'applications.text.statusDate': 'Date',
  'applications.text.statusReason': 'Rejection Reason',
  'applications.text.statusUser': 'User',

  'applications.text.message.success': 'Request {name} was {action} successfully',
  'applications.text.message.error': 'Request {name} could not be {action}',
  'applications.text.message.processInstanceStatusChange':
    'The request status has changed, you will be redirected to the details view shortly.',

  'applications.text.message.commandType1': 'approved',
  'applications.text.message.commandType2': 'rejected',
  'applications.text.message.commandType3': 'completed',
  'applications.text.message.commandType4': 'executed',
  'applications.text.message.commandType5': 'signed',
  'applications.text.message.commandType6': 'canceled',
  'applications.text.message.commandType7': 'voided',
  'applications.text.message.commandType8': 'sent',
  'applications.text.message.commandType9': 'evaluated',
  'applications.text.message.commandType10': 'reverted',
  'applications.text.message.commandType11': 'reassigned',
  'applications.text.message.commandType12': 'executed',
  'applications.text.message.commandType15': 'assigned',
  'applications.text.message.commandType28': 'canceled',
  'applications.text.message.commandType29': 'voided',

  'applications.text.googleIntegrationOperationType1': 'Upload File',
  'applications.text.googleIntegrationOperationType2': 'Download File',

  'application.text.googleOperationType.download-file': 'Download File',
  'application.text.googleOperationType.upload-file': 'Upload File',
  'application.text.googleServiceType.google-drive': 'Google Drive',

  'application.text.fptOperationType.download-file': 'Download File',
  'application.text.fptOperationType.upload-file': 'Upload File',

  'applications.text.openAIOperationType.parser': 'Parser',
  'applications.text.openAIOperationType.generic': 'Generic',
  'applications.text.automyAIHandlerType.agent': 'Agent',
  'applications.text.automyAIHandlerType.completions': 'Completions',
  'applications.text.automyAIHandlerType.responses': 'Responses',

  // Semantic per-action-type label keys
  'applications.text.executeApiCall.connectionName': 'API Connection',
  'applications.text.runCode.connectionName': 'Connection',
  'applications.text.runCode.programmingLanguage': 'Language',
  'applications.text.executeQuery.connectionName': 'Database Connection',
  'applications.text.executeQuery.databaseName': 'Database Name',
  'applications.text.executeQuery.databaseQuery': 'Database Query',
  'applications.text.dynamicEntityOperation.entityName': 'Dynamic Entity',
  'applications.text.dynamicEntityOperation.operationType': 'Operation',
  'applications.text.startProcessInstance.processName': 'Process',
  'applications.text.openAI.connectionName': 'API Connection',
  'applications.text.openAI.operationType': 'Operation',
  'applications.text.openAI.model': 'Model',
  'applications.text.automyAI.handlerType': 'Handler Type',
  'applications.text.automyAI.agentName': 'Agent',
  'applications.text.automyAI.model': 'Model',
  'applications.text.googleIntegration.connectionName': 'Connection',
  'applications.text.googleIntegration.serviceType': 'Service',
  'applications.text.googleIntegration.operationType': 'Operation',
  'applications.text.ftpOperation.connectionName': 'Connection',
  'applications.text.ftpOperation.operationType': 'Operation',
  'applications.text.executeProcessAction.actionName': 'Action',
  'applications.text.executeProcessAction.processName': 'Process',
  'applications.text.scheduledExecution.startDate': 'Scheduled Execution Date and Time',
  'applications.text.scheduledExecution.finishedDate': 'Finished Date',
  'applications.text.generateDocuments.finishedDateTime': 'Finished Date',
  'applications.text.sharePointOperation.connectionName': 'SharePoint Configuration',
  'applications.text.sharePointOperation.operationType': 'Operation',
  'applications.text.internalOperation.operationType': 'Operation Type',
  'applications.text.internalOperation.entityType': 'Entity',
  'applications.text.generatePlainTextFile.fileFormat': 'Format',
  'applications.text.generatePlainTextFile.sourceForm': 'Source Form',
  'applications.text.generatePlainTextFile.sourceField': 'Source Field',
  'applications.text.importPlainTextFile.fileFormat': 'Format',
  'applications.text.importPlainTextFile.sourceForm': 'Source Form',
  'applications.text.importPlainTextFile.sourceField': 'Source Field',
  'applications.text.consumeSequence.sequenceName': 'Sequence',
  'applications.text.consumeSequence.pattern': 'Pattern',
  'applications.text.executeRpaFlow.agentName': 'RPA Agent',
  'applications.text.executeRpaFlow.flowName': 'RPA Flow',
  'applications.text.integration.integrationName': 'Integration',
  'applications.text.integration.functionName': 'Function',
  'applications.text.whatsAppBusinessIntegration.connectionName': 'Connection',
  'applications.text.whatsAppBusinessIntegration.operationType': 'Operation Type',
  'applications.text.microsoftTeamsIntegration.connectionName': 'Connection',
  'applications.text.waitForChildRequests.overdueDate': 'Due Date and Time',
  'applications.text.waitForChildRequests.results': 'Result wait for child requests',
  'applications.text.waitChildRequests.tab.children': 'Child Requests',
  'applications.text.waitChildRequests.summary.resultType': 'Result type',
  'applications.text.waitChildRequests.summary.scope': 'Scope',
  'applications.text.waitChildRequests.summary.startActionId': 'Start action ID',
  'applications.text.waitChildRequests.summary.startActionName': 'Start action name',
  'applications.text.waitChildRequests.summary.completionMode': 'Completion mode',
  'applications.text.waitChildRequests.summary.targetActionId': 'Target action ID',
  'applications.text.waitChildRequests.summary.targetActionName': 'Target action name',
  'applications.text.waitChildRequests.summary.maxWaitTimeUnit': 'Max wait time unit',
  'applications.text.waitChildRequests.summary.maxWaitTimeValue': 'Max wait time value',
  'applications.text.waitChildRequests.summary.timeoutBehavior': 'Timeout behavior',
  'applications.text.waitChildRequests.summary.timeoutDate': 'Timeout date',
  'applications.text.waitChildRequests.summary.noChildrenBehavior': 'No children behavior',
  'applications.text.waitChildRequests.summary.childrenFailureBehavior':
    'Children failure behavior',
  'applications.text.waitChildRequests.summary.totalChildrenCount': 'Total children',
  'applications.text.waitChildRequests.summary.pendingChildrenCount': 'Pending children',
  'applications.text.waitChildRequests.summary.succeededChildrenCount': 'Succeeded children',
  'applications.text.waitChildRequests.summary.failedChildrenCount': 'Failed children',
  'applications.text.waitChildRequests.summary.lastEvaluationDateTime': 'Last evaluation',
  'applications.text.waitChildRequests.summary.completedDateTime': 'Completed date/time',
  'applications.text.waitChildRequests.items.childRequest': 'Child request',
  'applications.text.waitChildRequests.items.status': 'Status',
  'applications.text.waitChildRequests.items.childProcessInstanceStatus': 'Child request status',
  'applications.text.waitChildRequests.items.targetActionInstanceStatus': 'Target action status',
  'applications.text.waitChildRequests.items.failureReason': 'Failure reason',
  'applications.text.waitChildRequests.items.observations': 'Observations',
  'applications.text.waitChildRequests.items.lastEvaluationDateTime': 'Last evaluation',
  'applications.text.waitChildRequests.items.completedDateTime': 'Completed date/time',
  'applications.text.waitChildRequestsItemStatus.pending': 'Pending',
  'applications.text.waitChildRequestsItemStatus.success': 'Success',
  'applications.text.waitChildRequestsItemStatus.failed': 'Failed',
  'applications.text.processInstanceStatus.execution': 'Execution',
  'applications.text.processInstanceStatus.approved': 'Approved',
  'applications.text.processInstanceStatus.rejected': 'Rejected',
  'applications.text.processInstanceStatus.canceled': 'Canceled',
  'applications.text.processInstanceStatus.voided': 'Voided',
  'applications.text.processInstanceStatus.error': 'Error',
  'applications.text.waitChildRequestsItemFailureReason.none': 'None',
  'applications.text.waitChildRequestsItemFailureReason.childrejected': 'Child rejected',
  'applications.text.waitChildRequestsItemFailureReason.childcanceled': 'Child canceled',
  'applications.text.waitChildRequestsItemFailureReason.childvoided': 'Child voided',
  'applications.text.waitChildRequestsItemFailureReason.childerror': 'Child error',
  'applications.text.waitChildRequestsItemFailureReason.childfinishedwithouttargetaction':
    'Child finished without target action',
  'applications.text.waitChildRequestsItemFailureReason.targetactionerror': 'Target action error',
  'applications.text.waitChildRequestsItemFailureReason.targetactionnotsuccessful':
    'Target action not successful',
  'applications.text.waitChildRequestsResultType.none': 'None',
  'applications.text.waitChildRequestsResultType.nochildren': 'No children',
  'applications.text.waitChildRequestsResultType.allsucceeded': 'All succeeded',
  'applications.text.waitChildRequestsResultType.somefailed': 'Some failed',
  'applications.text.waitChildRequestsResultType.allfailed': 'All failed',
  'applications.text.waitChildRequestsResultType.timedout': 'Timed out',
  'applications.text.waitChildRequestsScope.allcurrentchildren': 'All current children',
  'applications.text.waitChildRequestsScope.childrenstartedbyspecificaction':
    'Children started by specific action',
  'applications.text.waitChildRequestsCompletionMode.untilchildrenfinish': 'Until children finish',
  'applications.text.waitChildRequestsCompletionMode.untilchildrencompletespecificaction':
    'Until children complete specific action',
  'applications.text.waitChildRequestsTimeoutBehavior.continue': 'Continue',
  'applications.text.waitChildRequestsTimeoutBehavior.throwerror': 'Throw error',
  'applications.text.waitChildRequestsNoChildrenBehavior.continue': 'Continue',
  'applications.text.waitChildRequestsNoChildrenBehavior.throwerror': 'Throw error',
  'applications.text.waitChildRequestsChildrenFailureBehavior.continuealways': 'Continue always',
  'applications.text.waitChildRequestsChildrenFailureBehavior.throwerrorifanyfailed':
    'Throw error if any failed',
  'applications.text.waitChildRequestsChildrenFailureBehavior.throwerrorifallfailed':
    'Throw error if all failed',
  'applications.text.frequencyUnit.none': 'None',
  'applications.text.frequencyUnit.minute': 'Minute',
  'applications.text.frequencyUnit.hour': 'Hour',
  'applications.text.frequencyUnit.day': 'Day',
  'applications.text.frequencyUnit.month': 'Month',
  'applications.text.frequencyUnit.businessday': 'Business day',

  'applications.text.automyAIHandlerType.1': 'Completions',
  'applications.text.automyAIHandlerType.2': 'Agent',
  'applications.text.automyAIHandlerType.3': 'Responses',

  'applications.text.resourceType1': 'User',
  'applications.text.resourceType2': 'External User',
  'applications.text.resourceType3': 'Webhook',
  'applications.text.resourceType4': 'Process Instance Action Start Process',
  'applications.text.resourceType5': 'Process Trigger',
  'applications.text.resourceType6': 'Scheduled Process',
  'applications.text.resourceType7': 'Bulk Task',
  'applications.text.id': 'Identifier',
  'applications.text.actionInstanceId': 'Action Instance Identifier',

  'applications.text.opsResultStatusType0': 'Pending',
  'applications.text.opsResultStatusType1': 'Executing',
  'applications.text.opsResultStatusType2': 'Success',
  'applications.text.opsResultStatusType3': 'Error',
  'applications.text.opsResultStatusType4': 'Failed',

  'applications.text.operationResultStatus.pending': 'Pending',
  'applications.text.operationResultStatus.executing': 'Executing',
  'applications.text.operationResultStatus.success': 'Success',
  'applications.text.operationResultStatus.error': 'Error',
  'applications.text.operationResultStatus.failed': 'Failed',

  'applications.text.automyAIHandlerType.completions': 'Completions',
  'applications.text.automyAIHandlerType.agent': 'Agent',
  'applications.text.automyAIHandlerType.responses': 'Responses',

  'application.message.backgroundData': 'The form is loading background data.',
};
